import Select from 'react-select';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 SELECT CON BÚSQUEDA — react-select

    ⚠️ EL MENÚ QUE NO SE VEÍA

    Con menuPortalTarget el menú sale al <body>, y react-select le pone
    z-index: 1 INLINE. Cualquier cosa con z-index mayor lo tapa — el
    header vale 1020 y el panel de desarrollo 2000.

    Un estilo inline no se puede pisar desde CSS: hay que subirlo con
    el prop `styles`. Es la ÚNICA propiedad que va en JS; todo el resto
    de la estética va por classNamePrefix, para que siga el tema.
*/

const PORTAL_STYLES = {
    menuPortal: (base) => ({ ...base, zIndex: 1100 }),
};

export const FieldSelectSearch = ({
    id, name, label, hint, error,
    value, onChange, options = [],
    placeholder = 'Buscar…', noOptionsText = 'Sin resultados',
    isMulti = false, isClearable = true, isSearchable = true,
    isRequired = false, isDisabled = false, isLoading = false,
    selectRef = null,
    span = 1, ...rest
}) => {

    const DOM_ID = useDomFieldId(id);

    return (

    <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
        isRequired={isRequired} isDisabled={isDisabled} span={span} >

        <Select
            ref={selectRef}
            inputId={id} name={name ?? id}
            className={`${BLOCK}__rs`} classNamePrefix="LS__rs"
            value={value} onChange={onChange} options={options}
            placeholder={placeholder}
            noOptionsMessage={() => noOptionsText}
            isMulti={isMulti} isClearable={isClearable} isSearchable={isSearchable}
            isDisabled={isDisabled} isLoading={isLoading}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            styles={PORTAL_STYLES}
            {...rest}
        />

    </FieldShell>
);
};
